/* ----------------------------------------------------------------
// This plugin requires lp-collapsible-container.js
// and lp-collapsible-container.scss
----------------------------------------------------------------*/
(($) => {

	$.fn.lpAccordion = function (options) {

		const defaults = { otherCollapseWhenOpen: true },
			config = $.extend({}, defaults, options);

		return this.each(function () {

			const $accordionParent = $(this),
				$accordionItems = $accordionParent.children('.lpCollapsible');

			$accordionParent.on('lpCollapsible:collapseAll', () => {

				$accordionItems.each(function () {

					$(this).trigger('lpCollapsible:collapse');

				});

			});

			$accordionParent.find('.lpAccordionCloseAll').on('click', () => {

				$(this).trigger('lpCollapsible:collapseAll');

			});

			$accordionItems.each(function () {

				// Make each accordion .lpCollapsible a collapsible container.
				$(this)
					.lpCollapsibleContainer()
					.on('lpCollapsible:expand', (e) => {

						e.stopPropagation();
						
						if (config.otherCollapseWhenOpen) {
							
							$accordionItems
								.filter(function () {

									return $(this)[0] != e.target;

								})
								.each(function () {

									$(this).trigger('lpCollapsible:collapse');

								});
						}

					});

			});

		});

	};

})(jQuery);
